import { useEffect, useState } from "react";
import { getPreferredLanguage } from "../utils/languageUtils";

interface OriginalDescription {
    text: string | string[] | null;
    lang: string;
}

function useLocalizedDescription<T extends string | string[]>(
    defaultDescription: T,
    originalDescription?: OriginalDescription | null
): T {
    const [currentLang, setCurrentLang] = useState(getPreferredLanguage());
    const [description, setDescription] = useState(defaultDescription);

    useEffect(() => {
        if (window.Weglot) {
            const observer = new MutationObserver(() => {
                const wgLang = getPreferredLanguage();
                setCurrentLang(wgLang);
            });

            observer.observe(document.documentElement, {
                attributes: true,
                attributeFilter: ["lang"],
            });

            return () => observer.disconnect();
        }
    }, []);

    useEffect(() => {
        if (
            originalDescription &&
            originalDescription.text &&
            originalDescription.lang === currentLang
        ) {
            setDescription(originalDescription.text as T);
        } else {
            setDescription(defaultDescription);
        }
    }, [defaultDescription, originalDescription, currentLang]);

    return description;
}

export default useLocalizedDescription;
